export const maxHeight = 108;
export const maxWeight = 1000;
export const LBS_IN_KG = 0.453592;
export const INCHES_IN_CM = 0.393701;
export const FOOT_IN_CM = 0.0328084;
